import { CountryCode } from "libphonenumber-js";

export interface IntegrationDataObject {
  integrationData?: Record<string, any>;
}

export interface SiteObject extends OrganisationObject {
  siteId: string;
}

export interface GeneralObject extends IntegrationDataObject {
  id: string;
  createdTime: string;
  updatedTime: string;
}

export interface OrganisationObject extends GeneralObject {
  orgId: string;
}

export interface OrgSettings {
  customerSignInOptions: CustomerSignInOptions;
  loyaltySettings?: LoyaltySettings;
  giftCardSettings: GiftCardSettings;
  paymentSettings: PaymentSettings;
}

export enum CardSavingType {
  _NOT_SET = "",
  DISABLED = "DISABLED",
  OPTION_BEFORE_PAYMENT = "OPTION_BEFORE_PAYMENT",
  POPUP_BEFORE_PAYMENT = "POPUP_BEFORE_PAYMENT",
  POPUP_AFTER_PAYMENT = "POPUP_AFTER_PAYMENT",
}

export enum SavedCardPaymentFlow {
  _NOT_SET = "",
  SESSION = "SESSION",
  TRANSACTION = "TRANSACTION",
}

export interface PaymentSettings {
  cardSavingType: CardSavingType;
  savedCardPaymentFlow: SavedCardPaymentFlow;
}

export interface GiftCardSettings {
  expirationDays: number | null;
}

export interface CustomerSignInOptions {
  passwordless: {
    email: boolean;
    sms: boolean;
  };
  signInWith: {
    google: boolean;
    apple: boolean;
  };
  smsAllowedCountryCodes: CountryCode[];
}

export interface LoyaltySettings {
  loyaltyLink: string;
  loyaltyName: string;
  required: boolean;
  loyaltyIcon: FileReference | null;
  balanceUnitName: string;
  balanceIsMonetary: boolean;
  promotionName: string;
}

export interface FileReference {
  fileId: string;
  fileName: string;
  modifiers: string | null;
}

export interface Availability {
  applies: DaysOfWeek;
  startsAt: TimeOfDay;
  endsAt: TimeOfDay;
}

export type DaysOfWeek = {
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
};

export type TimeOfDay = {
  hour: number;
  minute: number;
};

export type TemplateElementGroup = {
  title?: string;
  titlePosition?: HorizontalPosition;
  items: TempleteElementGroupItem[];
};

export type TempleteElementGroupItem = {
  label: string | null;
  url: string | null;
  leftIcon: SocialIcon | null;
  rightIcon: SocialIcon | null;
  type: TemplateElement;
  children: TempleteElementGroupItem[] | null;
  position?: HorizontalPosition;
  image?: FileReference | null;
};

export enum TemplateElement {
  Link = "link",
  StyledLink = "styledLink",
  Button = "button",
  Text = "text",
  Socials = "socials",
  Copyright = "copyright",
  Image = "image",
  Row = "row",
}

export type SocialItem = {
  url: string;
  icon: SocialIcon;
  customIcon: FileReference | null;
};

export enum SocialIcon {
  Instagram = "instagram",
  Facebook = "facebook",
  Twitter = "twitter",
  Pinterest = "pinterest",
  Tiktok = "tiktok",
  Youtube = "youtube",
  Yelp = "yelp",
  Google = "google",
  Discord = "discord",
  Linkedin = "linkedin",
  Intercom = "intercom",
  Apple = "apple",
  Android = "android",
  Generic = "generic",
}

export enum HorizontalPosition {
  Left = "LEFT",
  Center = "CENTER",
  Right = "RIGHT",
}
